import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { FormGroup, Label } from './styles/common';
import { reactSelectStyles } from './reactSelectStyles';

// Moto twin of FormReactSelectModel — identical behaviour and v2 styling,
// keyed on `moto_model_code`.
function FormReactSelectMotoModel({
  label, options, error, valid, onChange, values,
}) {
  const [prepOptions, setPrepOptions] = useState([]);
  const [inputText, setInputText] = useState('');

  const handleChange = (value) => {
    if (value.moto_model_code !== undefined || value.moto_model_code !== '') {
      const model = options.find((opt) => opt.id == value.moto_model_code);
      if (model !== undefined) {
        onChange({
          moto_model_code: model.id.toString(),
        });
      }
    }

    if (value.moto_model_code === null || value.moto_model_code === '' || value.moto_model_code === undefined) {
      onChange({
        moto_model_code: '',
      });
    }
  };

  const handleInputChange = (inputValue) => {
    setInputText(inputValue);
  };

  const handleMenuClose = () => {
    if (!values.moto_model_code && inputText) {
      const startingWithOptions = prepOptions.filter((option) => option.label.toLowerCase().startsWith(inputText.toLowerCase()));
      const firstStartingOption = startingWithOptions[0];
      const found = firstStartingOption
        && options.find((opt) => opt.id == firstStartingOption.value);
      if (firstStartingOption && found) {
        onChange({
          moto_model_code: firstStartingOption.value.toString(),
        });
      }
    }
  };

  useEffect(() => {
    setPrepOptions(options.map((i) => ({ value: i.id, label: i.name })));
  }, [options]);

  return (
    <FormGroup>
      <Label>{label}</Label>
      <Select
        onMenuClose={handleMenuClose}
        onInputChange={handleInputChange}
        options={prepOptions}
        isSearchable
        placeholder="Cerca il modello..."
        value={options.filter((opt) => opt.id == values.moto_model_code).map((o) => ({ value: o.id, label: o.name }))[0]}
        onChange={(val) => {
          handleChange({
            moto_model_code: val === null || val === undefined ? '' : val.value,
          });
        }}
        loadingMessage={() => 'Caricando modelli...'}
        clearValue
        isClearable
        noOptionsMessage={() => 'Modelli non trovati!'}
        styles={reactSelectStyles({ error, valid })}
      />
      <div className="invalid-feedback">{error}</div>
    </FormGroup>
  );
}

export default FormReactSelectMotoModel;
